export enum TipoCriador {
  Admin = 1,
  Motorista,
  Responsavel,
}
